import { Link } from "react-router-dom";
import { CircleAlert } from "lucide-react";

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

const AccessDenied = ({
  description = "You don't have permission to view this page.",
}) => (
  <div className="tw:w-full">
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <CircleAlert />
        </EmptyMedia>
        <EmptyTitle>Access denied</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      <Link to="/">Back to home</Link>
    </Empty>
  </div>
);

export default AccessDenied;
